import axios from 'axios';

import { getApiUrl } from './urls';

axios.defaults.baseURL = getApiUrl();
